// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planning-pingflo {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.planning-pingflo__mic {
  appearance: none;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color));
  background:
    linear-gradient(
      160deg,
      color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--surface-color)) 0%,
      var(--surface-color) 70%
    );
  color: var(--text-color);
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  cursor: pointer;
  box-shadow: 0 4px 14px var(--shadow-color);
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.planning-pingflo__mic:hover:not(:disabled) {
  transform: translateY(-1px);
  border-color: var(--brand-primary, #0877bc);
}

.planning-pingflo__mic:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.planning-pingflo__mic.is-listening,
.planning-pingflo__mic.is-open {
  border-color: var(--brand-primary, #0877bc);
  box-shadow:
    0 0 0 3px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent),
    0 6px 16px var(--shadow-color);
}

.planning-pingflo__mark {
  display: grid;
  place-items: center;
  line-height: 0;
}

.psg-board__pingflo-slot {
  position: relative;
  flex: 0 0 auto;
  min-width: 0;
  max-width: min(100%, 420px);
}

.psg-board--pingflo-open .psg-board__pingflo-slot {
  /* Caption is absolutely positioned; don't reserve empty vertical space. */
  min-height: 0;
}

.planning-pingflo__portal {
  position: absolute;
  inset: auto 0 0 0;
  z-index: 30;
}

.psg-board__pingflo-slot .lt-pingflo-voice__caption {
  width: 100%;
  max-width: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/planning/PlanningPingfloVoice.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4FAA4F;EAC5F;;;;;KAKG;EACH,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,2CAA2C;EAC3C;;kCAEgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,0EAA0E;EAC1E,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[".planning-pingflo {\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.planning-pingflo__mic {\n  appearance: none;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 35%, var(--border-color));\n  background:\n    linear-gradient(\n      160deg,\n      color-mix(in srgb, var(--brand-primary, #0877bc) 18%, var(--surface-color)) 0%,\n      var(--surface-color) 70%\n    );\n  color: var(--text-color);\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  box-shadow: 0 4px 14px var(--shadow-color);\n  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.planning-pingflo__mic:hover:not(:disabled) {\n  transform: translateY(-1px);\n  border-color: var(--brand-primary, #0877bc);\n}\n\n.planning-pingflo__mic:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.planning-pingflo__mic.is-listening,\n.planning-pingflo__mic.is-open {\n  border-color: var(--brand-primary, #0877bc);\n  box-shadow:\n    0 0 0 3px color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent),\n    0 6px 16px var(--shadow-color);\n}\n\n.planning-pingflo__mark {\n  display: grid;\n  place-items: center;\n  line-height: 0;\n}\n\n.psg-board__pingflo-slot {\n  position: relative;\n  flex: 0 0 auto;\n  min-width: 0;\n  max-width: min(100%, 420px);\n}\n\n.psg-board--pingflo-open .psg-board__pingflo-slot {\n  /* Caption is absolutely positioned; don't reserve empty vertical space. */\n  min-height: 0;\n}\n\n.planning-pingflo__portal {\n  position: absolute;\n  inset: auto 0 0 0;\n  z-index: 30;\n}\n\n.psg-board__pingflo-slot .lt-pingflo-voice__caption {\n  width: 100%;\n  max-width: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
